<!--- COMPONENTE UCDatosComplementarios  ---->
<!--
Descripción del componente:
---------------------------
- Incluye una lista con los datos complementarios de la entidad.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div>
    <div>
      <!-- Preloader de carga -->
      <UCPreload
        v-if="mostrarPrecarga"
        :numero-elementos="1"
      />
      <div
        v-if="edition"
        class="content-data-list"
      >
        <f7-list
          id="list-form"
        >
          <div
            v-for="(dc, i) in datosComplementarios"
            :key="i"
            class=""
          >
            <div
              v-if="dc.TipoDatoComplementario === 0"
              class="margin"
            >
              <span
                v-if="dc.Requerido"
                class="complementary-data-required"
              >*</span>
              <span class="display-flex">{{ dc.Nombre }}</span>
              <f7-list-input
                class="input-normal"
                item-label
                type="text"
                required
                :value="dc.Valor.Valor != null ? dc.Valor.Valor : ''"
                @input="ChangeValueData($event.target.value, i)"
              />
            </div>
            <div
              v-if="dc.TipoDatoComplementario === 1"
              class="margin"
            >
              <span
                v-if="dc.Requerido"
                class="complementary-data-required"
              >*</span>
              <span class="display-flex">{{ dc.Nombre }}</span>
              <f7-list-input
                v-if="dc.TipoDatoComplementario === 1"
                class="input-normal"
                item-label
                type="date"
                required
                :value="dc.Valor.Valor != null ? dc.Valor.Valor : ''"
                @input="ChangeValueData($event.target.value, i)"
              />
            </div>
            <div
              v-if="dc.TipoDatoComplementario === 2"
              class="margin"
            >
              <span class="display-flex">
                <span
                  v-if="dc.Requerido"
                  class="complementary-data-required"
                >*</span>
                {{ dc.Nombre }}
              </span>
              <f7-list-input
                v-if="dc.TipoDatoComplementario === 2"
                class="input-normal"
                item-label
                type="number"
                required
                :value="dc.Valor.Valor != null ? dc.Valor.Valor : ''"
                @input="ChangeValueData($event.target.value, i)"
              />
            </div>
            <div
              v-if="dc.TipoDatoComplementario === 4"
              class="margin"
            >
              <span class="display-flex">
                <span
                  v-if="dc.Requerido"
                  class="complementary-data-required"
                >*</span>
                {{ dc.Nombre }}
              </span>
              <UCSearchEntityERP
                v-if="dc.TipoDatoComplementario === 4"
                class="margin-top-half"
                :default-value="dc.Valor.Valor != null ? dc.Valor : null"
                :search-text="$t('supplementaryData.searching')"
                :search-cancellation-text="$t('common.searchCancelled')"
                :search-not-found-text="$t('supplementaryData.notFound')"
                :default-etities-list="dc.ListaValoresParaSeleccion"
                :property-entity-shown-input="['Valor']"
                :property-entity-shown-list-title="['Valor']"
                :search-in="['.item-title']"
                @selection="(value) => ChangeValueData(value?.Valor, i)"
              />
            </div>
          </div>
        </f7-list>
      </div>

      <div
        v-else
        class="content-data-list"
      >
        <div class="grid-3 content-data-list__title">
          <div>{{ $t('common.code') }}</div>
          <div>{{ $t('common.name') }}</div>
          <div>{{ $t('common.value') }}</div>
        </div>
        <div
          v-for="(dc, i) in datosComplementarios"
          :key="i"
          class="grid-3 content-data-list__data"
        >
          <div v-if="dc.Codigo !== ''">
            {{ FormatearCadena(dc.Codigo, 25) }}
          </div>
          <div v-if="dc.Nombre !== ''">
            {{ FormatearCadena(dc.Nombre, 25) }}
          </div>
          <div v-if="dc.Valor !== ''">
            {{ FormatearCadena(dc.Valor, 25) }}
          </div>
        </div>
      </div> <!-- Fin registro -->
      <span v-if="datosComplementarios.length === 0 && !mostrarPrecarga">
        {{ $t('supplementaryData.noData') }}
      </span>
    </div>
  </div>
</template>

<script>
import SoporteCadena from '@/js/common/HiChainSupport';
import { Log } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import { HiNotification } from '@/js/common/HINotificationSupport';
import ConexionTA from '../../js/services/traceability/APITraceability';
import UCPreload from './UCPreload.vue';

export default {
  name: 'UCDatosComplementarios',
  components: {
    UCPreload,
    UCSearchEntityERP,
  },
  props: {
    defaultDatosComplementarios: { // si le pasamos un array de datos complementarios no cargara los valores del back  pj si los tenemos en local y necesitamos que usuario pueda modificar antes de guardar
      type: Array,
      default: () => [],
    },
    entidadSeleccionada: {
      type: Object,
      default: null,
    },
    tipoEntidadSeleccionada: {
      type: String,
      default: '',
    },
    activo: {
      type: Boolean,
      default: false,
    },
    edition: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['change-complementary-data'],

  data() {
    return {
      datosComplementarios: [],
      mostrarPrecarga: false, // Controla si se muestra el componente de precarga.
    };
  },

  created() {
    this.InicializarComponente();
  },

  methods: {
    async InicializarComponente() {
      Log(this, 'UCDatosComplementarios->InicializarComponente');
      if (this.entidadSeleccionada != null && this.activo) {
        await this.ObtenerDatosComplementariosEntidadSeleccionada();
      }
      if (this.defaultDatosComplementarios.length > 0) {
        this.setDefaultValues();
      }
      const copiaDatosComplementarios = Array.from(this.datosComplementarios);
      this.$emit('change-complementary-data', copiaDatosComplementarios);
    },
    FormatearCadena(cadena, longitudMaxima) {
      if (cadena == null) {
        return '';
      }
      return SoporteCadena.TextoLogitudMaxima(cadena, longitudMaxima);
    },
    ChangeStructure() {
      Log(this, this.ChangeStructure.name);
      this.datosComplementarios.forEach((element) => {
        element.Valor = { Valor: element.Valor };
        const newListValues = [];
        element.ListaValoresParaSeleccion.forEach((secElement) => {
          const item = { Valor: secElement };
          newListValues.push(item);
        });
        element.ListaValoresParaSeleccion = newListValues;
      });
    },
    setDefaultValues() {
      this.defaultDatosComplementarios.forEach((defaultDc) => {
        this.datosComplementarios.forEach((dc) => {
          if (dc.Id === defaultDc.Id) {
            dc.Valor.Valor = defaultDc.Valor;
          }
        });
      });
    },
    ChangeValueData(value, index) {
      Log(this, this.ChangeValueData.name);
      if (value) {
        this.datosComplementarios[index].Valor.Valor = value;
        const copiaDatosComplementarios = Array.from(this.datosComplementarios);
        this.$emit('change-complementary-data', copiaDatosComplementarios);
      }
    },
    async ObtenerDatosComplementariosEntidadSeleccionada() {
      Log(this, this.ObtenerDatosComplementariosEntidadSeleccionada.name);
      this.mostrarPrecarga = true;
      await ConexionTA.callObtenerDatosComplementariosEntidadSeleccionada(this.entidadSeleccionada.Id, this.tipoEntidadSeleccionada, this.edition).then((result) => {
        if (result.Valor) {
          this.datosComplementarios = JSON.parse(result.Mensaje);
          this.ChangeStructure();
          this.mostrarPrecarga = false;
        } else {
          this.mostrarPrecarga = false;
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      })
        .catch(() => {
          this.mostrarPrecarga = false;
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
        });
    },
  },
};
</script>

<style lang="scss">
.content-data-list {
  --search-title-font-size: 16px;
  --search-title-margin-left: 10px;
  --search-input-color: var(--his-oliva-dark);
  --search-input-font-size: 16px;
  --search-input-padding-left: 10px;

  // margin-bottom: 20px;
  &__title {
    color: var(--his-oliva);
    font-size: 14px;
    font-weight: 500;
  }

  &__data {
    color: var(--his-steel-blue);
    font-size: 16px;
    font-weight: 500;
    padding-top: 5px;
  }

  .grid-3 {
    display: grid;
    grid-template-columns: 1fr 2fr 2fr;
    grid-column-gap: 10px;
  }

  .input-normal {
    margin-top: 1vh;
    height: 45px;

    .item-link {
      .item-content {
        margin-left: 15px;
      }
    }
  }

  .list {
    .item-content {
      .item-inner {
        .item-title {
          font-size: 14px;
          color: var(--his-darkness);
        }

        .item-input-wrap {
          .input-with-value {
            font-size: 16px;
            color: var(--his-oliva-dark);
          }
        }
      }
    }

    .content-searcher-erp {
      margin-left: 15px;
      margin-right: 15px;
    }
  }

  .complementary-data-required {
    color: var(--his-tomate-dark);
  }
}
</style>
